/**
 * Faculty Communication
 */
import { z } from 'zod';
import {
  FacultyCommunicationId,
  FacultyId,
  UserId,
  UnixTimestamp,
} from '../types/branded';
import {
  CommunicationChannelSchema,
  CommunicationStatusSchema,
} from '../types/enums';
import { FacultyAssetDescriptorSchema } from './faculty-asset';

const FacultyCommunicationAttachmentListSchema = z.array(
  z.preprocess((value) => {
    if (typeof value === 'string') {
      return {
        resourceId: value,
        fileName: value,
      };
    }
    return value;
  }, FacultyAssetDescriptorSchema),
).default([]);

export const FacultyCommunicationSchema = z.object({
  id: FacultyCommunicationId,
  facultyId: FacultyId,
  channel: CommunicationChannelSchema,
  status: CommunicationStatusSchema,
  senderLabel: z.string().optional(),
  recipient: z.string().min(1).optional(),
  subject: z.string().min(1).optional(),
  body: z.string().min(1).optional(),
  attachments: FacultyCommunicationAttachmentListSchema,
  outboxId: z.string().min(1).optional(),
  providerMessageId: z.string().min(1).optional(),
  sentAt: UnixTimestamp.nullable().optional(),
  lastError: z.string().nullable().optional(),
  error: z.string().nullable().optional(),
  createdAt: UnixTimestamp,
  createdBy: UserId,
});
export type FacultyCommunication = z.infer<typeof FacultyCommunicationSchema>;
